<template>

  <span>

    <font-awesome-icon 
      v-for="(setting, settingsProcessedIndex) in settingsProcessed" 
      :key="'table-icon-'+settingsProcessedIndex"
      @click="clicked(setting)" 
      :icon="setting.icon" 
      :class="{'table-icon': true, svg: true, clickable: setting.click !== '' }" 
      :style="{ color: '#212426' }" 
      :title="setting.title?setting.title:''"
    />
  
  </span>

</template>

<script>
export default {
  name: 'TableIcon',
  props: ['settings'],
  data() {
    return {
      
    }
  },
  computed: {

    icons () {

      

    },
    settingsProcessed() {

      let settings = Array.isArray( this.settings ) ? this.settings : [this.settings], settingsProcessed = [];

      settings.forEach( ( setting ) => {

        if ( !setting.clicked ) setting.clicked = 'clicked';

        settingsProcessed.push( setting );

      });

      return settingsProcessed;

    }

  },
  methods: {
  
    clicked(setting) {

      if ( setting.click ) {

        this.$emit( setting.clicked, null );

      }

    }

  }
}
</script>
<style lang="less" scoped>
@import './../../assets/css/less/_helper.less';
.table-icon {

  width: 25px;
  height: 25px;
  
  &.clickable {
    cursor: pointer;
    .trans;
    .opacity(0.6);
    &:hover {
      .opacity(1);
    }
  }

}
@media screen and (min-width: 960px) {

  .table-icon {

    width: 20px;
    height: 20px;
    margin: 0;

  }

}
</style>